<template lang="pug">
    v-container( fluid )
        v-toolbar( flat )
            h1 Direcciones
            v-spacer
            v-toolbar-items
                v-btn( color="indigo darken-4" dark depressed @click="toggleAddAddress" ) Agregar
        v-divider
        div( v-if="editable" )
            CrudForm( :fields="formFields" v-bind="formDataEdit" @submitForm="editSubmitForm( $event )" )
        div( v-if="newAddress" )
            CrudForm(
                :fields="formFields"
                v-bind="formData"
                @submitForm="submitForm( $event )"
                @reset="cleanBranOffice()"
                )
        v-list
            v-list-tile( v-for="(item, index) in items" :key="item.id" avatar )
                v-list-tile-avatar( :color="item.default_branch_office ? 'primary' : 'normal'" )
                    v-icon( :dark="item.default_branch_office" ) store
                v-list-tile-content
                    v-list-tile-title( v-text="`${item.address}`" )
                    //- v-list-tile-sub-title( v-text="`Comuna: ${item.g_commune.name} Email:${item.email} Fono:${item.phone}`" )
                    v-list-tile-sub-title( v-text="`${item.g_commune.name}`" )
                v-list-tile-action
                    v-layout(row wrap)
                        v-flex(md6)
                            v-btn( icon  )
                                v-icon( @click="editBranchOffice( index )" color="info" ) edit
                        v-flex(md6)
                            v-btn( icon v-if=" items.length > 1" )
                                v-icon( @click="showCustomerDeleteSnackbar( index )" color="red" ) delete
                    
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    //
    import CrudForm from '@/components/CrudForm/CrudForm'
    import CommuneService from '@/services/api/commune/CommuneService'
    import CustomerService from '@/services/api/customer/CustomerService'
    //
    import cities from '@/assets/cities.js'
    export default {
        components: {
            CrudForm
        },
        computed: {
            ...mapState('SnackbarModalModule', {
                responseConfirm: 'responseConfirm',
            }),
        },
        data () {

            return {
                editable: false,
                newAddress:false,
                formData: {
                    submitText: 'Agregar dirección',
                },
                formDataEdit:{
                    submitText: 'Editar dirección'
                },
                formFields: [
                    {
                        field: 'address',
                        type: 'text',
                        maxLength: 80,
                        value: '',
                        vuetifyProps: {
                            label: 'Dirección',
                        },
                        rules: [ 'required' ]
                    },
                    {
                        field: 'phone',
                        type: 'text',
                        maxLength: 12,
                        value: '',
                        vuetifyProps: {
                            label: 'Teléfono',
                        },
                    },
                    {
                        field: 'phone2',
                        type: 'text',
                        maxLength: 12,
                        value: '',
                        vuetifyProps: {
                            label: 'Teléfono 2',
                        },
                    },
                    {
                        field: 'email',
                        type: 'text',
                        maxLength: 30,
                        value: '',
                        vuetifyProps: {
                            label: 'Correo electrónico',
                        },
                        rules: [ 'email' ]
                    },
                    {
                        field: 'g_commune_id',
                        type: 'autocompleteObject',
                        value: 'La Serena',
                        vuetifyProps: {
                            label: 'Comuna',
                        },
                        options: {
                            data: [],
                            text : 'name',
                            value : 'id',
                        },
                        rules: [ 'required' ]
                    },
                    {
                        field: 'city',
                        type: 'autocomplete',
                        value: 'La Serena',
                        vuetifyProps: {
                            label: 'Ciudad',
                        },
                        options: cities,
                        rules: [ 'required' ]
                    },
                    {
                        field: 'zone',
                        type: 'text',
                        maxLength: 30,
                        value: '',
                        vuetifyProps: {
                            label: 'Sector',
                        },
                    },
                    {
                        field: 'default_branch_office',
                        type: 'checkbox',
                        maxLength: 12,
                        value: false,
                        vuetifyProps: {
                            label: 'Dirección por defecto',
                        },
                    },
                ],
                selectedItemIndex: null,
                indexEdited:null
            }
        },
        methods: {
            ...mapActions('SnackbarModalModule', {
                initSnackbar: 'initSnackbar',
                resetSnackbarState: 'resetSnackbarState',
                setMessageConfirmSnack: 'setMessageConfirmSnack',
            }),
            refresh () {
                //
                this.$router.go()
            },
            setCommuneData ( communes ) {
                //
                this.formFields[ 4 ].options.data = communes
                //
                this.formFields = [ ...this.formFields ]
            },
            showCustomerDeleteSnackbar ( index ) {
                //
                this.resetSnackbarState()
                this.showSnackbar( 'warning', '¿Deseas eliminar la dirección?', '', () => this.setMessageConfirmSnack( 'eliminar direccion' ) )
                //
                this.selectedItemIndex = index
            },
            async showSnackbar ( type, title, message, callback = () => {} ) {
                //
                this.resetSnackbarState()
                this.initSnackbar( this.fillSnack( type, title, message, false, 3000 ) ); callback()
            },
            async submitForm ( data ) {
                //
                let id       = this.$route.params.id,
                    customer = await CustomerService.fetchCustomer( id )
                //
                customer.branch_offices = [ 
                    ...customer.branch_offices,
                    data
                ]
                //
                this.newAddress = false
                //
                let response = await CustomerService.updateCustomer( id, customer )
                //
                switch ( response.status ) {
                    case 'success': return this.showSnackbar( 'success', 'Éxito.', 'Dirección agregada.', this.success );
                    case 'error':   return this.showSnackbar( 'error',   'Error.', this.xError( response.errors ) );
                }
            },
            async submitRemove () {
                //
                let id       = this.$route.params.id,
                    index    = this.selectedItemIndex,
                    customer = await CustomerService.fetchCustomer( id )
                //
                customer.branch_offices.splice( index, 1 )
                //
                let response = await CustomerService.updateCustomer( id, customer )
                //
                switch ( response.status ) {
                    case 'success': return this.showSnackbar( 'success', 'Éxito.', 'Dirección eliminada.', this.success );
                    case 'error':   return this.showSnackbar( 'error',   'Error.', this.xError( response.errors ) );
                }
            },
            toggleAddAddress () {
                //
                this.newAddress = !this.newAddress
                this.cleanBranOffice()
            },
            success () {
                //
                this.$emit( 'success' )
            },
            xError ( errors ) {
                return Object.values( errors ).reduce( ( prev, curr, init = [] ) => { return prev + curr.join( ', ' ) })
            },
            editBranchOffice ( index ) {

                this.fillBranchOffice(this.items[index])
                this.editable = true
                this.newAddress =false
                this.indexEdited = index
            },
            fillBranchOffice ( data ) {
                //
                this.formFields[0].value = data.address
                this.formFields[1].value = data.phone
                this.formFields[2].value = data.phone2
                this.formFields[3].value = data.email
                this.formFields[4].value = data.g_commune_id
                this.formFields[5].value = data.city
                this.formFields[6].value = data.zone
                this.formFields[7].value = data.default_branch_office
                //
                this.formFields = [...this.formFields]
            },
            cleanBranOffice(){
                this.formFields = this.formFields.map((f, idx) => {
                    f.value = ''
                    if(idx === 7) f.value = false
                    return f
                })
                //
                // this.formFields[0].value = ''
                // this.formFields[1].value = ''
                // this.formFields[2].value = ''
                // this.formFields[3].value = ''
                // this.formFields[4].value = false
                //
                // this.formFields = [...this.formFields]
            },
            async editSubmitForm( data ){
                //
                let id       = this.$route.params.id,
                    customer = await CustomerService.fetchCustomer( id )
                //
                customer.branch_offices.splice( this.indexEdited, 1 )
                //
                customer.branch_offices = [ 
                    ...customer.branch_offices,
                    data,
                ]
                //
                this.indexEdited =null
                this.editable = false
                //
                let response = await CustomerService.updateCustomer( id, customer )
                //
                switch ( response.status ) {
                    case 'success': return this.showSnackbar( 'success', 'Éxito.', 'Dirección editada.', this.success );
                    case 'error':   return this.showSnackbar( 'error',   'Error.', this.xError( response.errors ) );
                }
                
            },
            branchOfficeWereEdited(){

            }
        },
        async mounted () {
            //
            this.setCommuneData( await CommuneService.fetchCommunes() )
        },
        name: 'branch-offices-list',
        props: {
            items: [],
        },
        watch: {
            async responseConfirm ( message ) {
                switch ( message ) {
                    case 'eliminar direccion': return this.submitRemove()
                }
            },
        },
    }
</script>
